import React from 'react';
import AddressAutocompleteTextBox from 'views/components/AddressAutocompleteTextBox';

const HeadquarterQuestion = ({ value, onChange }) => (
  <div className="input-grid question-grid">
    <label>
      <p>Organization headquarters address</p>
      <AddressAutocompleteTextBox
        placeholder="Address or city name..."
        address={value || ''}
        onAddressChange={onChange}
        clearSelected={false}
        autoFocus={false}
      />
    </label>
  </div>
);

export default HeadquarterQuestion;
